/**
 * Hover mega-menu for desktop — smooth open/close every time.
 */
(function () {
  const OPEN_DELAY = 60;
  const CLOSE_DELAY = 150;

  function isDesktop() {
    return window.innerWidth >= 990;
  }

  function getHeaderWrapper() {
    return document.querySelector('.header-wrapper');
  }

  function positionCompactDropdown(details) {
    if (!details.classList.contains('mega-menu--compact')) return;

    const content = details.querySelector('.mega-menu__content--dropdown');
    const summary = details.querySelector('summary');
    const wrapper = getHeaderWrapper();
    if (!content || !summary || !wrapper) return;

    const wrapperRect = wrapper.getBoundingClientRect();
    const summaryRect = summary.getBoundingClientRect();
    const centerX = summaryRect.left + summaryRect.width / 2 - wrapperRect.left;
    const edgePadding = 12;

    function applyPosition() {
      const contentWidth = content.offsetWidth;
      let left = centerX - contentWidth / 2;
      const maxLeft = wrapperRect.width - contentWidth - edgePadding;
      left = Math.max(edgePadding, Math.min(left, maxLeft));
      content.style.setProperty('--dropdown-left', left + 'px');
    }

    applyPosition();
    requestAnimationFrame(applyPosition);
  }

  function clearCompactDropdown(details) {
    const content = details.querySelector('.mega-menu__content--dropdown');
    if (!content) return;
    content.style.removeProperty('--dropdown-left');
  }

  function delayMenuColumns(details) {
    details.querySelectorAll('.meganav-blocks .d-col-link').forEach(function (col, index) {
      col.style.setProperty('--mega-col-delay', (index + 1) * 0.08 + 's');
    });
  }

  function resetMenuColumns(details) {
    details.classList.remove('mega-menu--animating');
    details.querySelectorAll('.meganav-blocks .d-col-link').forEach(function (col) {
      col.style.removeProperty('--mega-col-delay');
      col.style.removeProperty('animation');
    });
  }

  function setHeaderPinned(open) {
    const wrapper = getHeaderWrapper();
    if (!wrapper) return;
    wrapper.preventHide = open;

    if (open && document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') === '') {
      document.documentElement.style.setProperty(
        '--header-bottom-position-desktop',
        Math.floor(wrapper.getBoundingClientRect().bottom) + 'px'
      );
    }
  }

  function openMenu(headerMenu) {
    const details = headerMenu.querySelector('details');
    if (!details) return;
    if (details.hasAttribute('open')) return;

    details.setAttribute('open', '');
    setHeaderPinned(true);
    positionCompactDropdown(details);

    if (details.classList.contains('mega-menu')) {
      details.classList.remove('mega-menu--animating');
      void details.offsetWidth;
      details.classList.add('mega-menu--animating');
      delayMenuColumns(details);
      setTimeout(function () {
        details.classList.remove('mega-menu--animating');
      }, 600);
    }
  }

  function closeMenu(headerMenu) {
    const details = headerMenu.querySelector('details');
    if (!details || !details.hasAttribute('open')) return;

    resetMenuColumns(details);
    clearCompactDropdown(details);
    details.removeAttribute('open');

    const stillOpen = document.querySelector('header-menu details[open]');
    if (!stillOpen) setHeaderPinned(false);
  }

  function repositionOpenCompactDropdowns() {
    if (!isDesktop()) return;
    document.querySelectorAll('details.mega-menu--compact[open]').forEach(positionCompactDropdown);
  }

  function initHoverMenus() {
    document.querySelectorAll('header-menu').forEach(function (headerMenu) {
      if (headerMenu.dataset.hoverInit === 'true') return;
      headerMenu.dataset.hoverInit = 'true';

      let openTimer = null;
      let closeTimer = null;

      function cancelTimers() {
        clearTimeout(openTimer);
        clearTimeout(closeTimer);
      }

      headerMenu.addEventListener('mouseenter', function () {
        if (!isDesktop()) return;
        cancelTimers();
        openTimer = setTimeout(function () {
          document.querySelectorAll('header-menu').forEach(function (other) {
            if (other !== headerMenu) closeMenu(other);
          });
          openMenu(headerMenu);
        }, OPEN_DELAY);
      });

      headerMenu.addEventListener('mouseleave', function () {
        if (!isDesktop()) return;
        cancelTimers();
        closeTimer = setTimeout(function () {
          closeMenu(headerMenu);
        }, CLOSE_DELAY);
      });

      const content = headerMenu.querySelector('.mega-menu__content');
      if (content) {
        content.addEventListener('mouseenter', cancelTimers);
        content.addEventListener('mouseleave', function () {
          if (!isDesktop()) return;
          cancelTimers();
          closeTimer = setTimeout(function () {
            closeMenu(headerMenu);
          }, CLOSE_DELAY);
        });
      }

      const summary = headerMenu.querySelector('summary');
      if (summary) {
        summary.addEventListener('click', function (e) {
          if (!isDesktop()) return;

          var caret = e.target.closest('.header__menu-caret, .icon-caret');
          var href = (summary.getAttribute('data-parent-url') || '').trim();
          if (!href) {
            var parentLink = summary.querySelector('.header__menu-parent-link');
            href = parentLink ? (parentLink.getAttribute('href') || '').trim() : '';
          }

          if (!caret && href && href !== '#' && (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey)) {
            return;
          }

          e.preventDefault();
          e.stopPropagation();

          if (!caret && href && href !== '#') {
            window.location.assign(href);
            return;
          }

          var details = headerMenu.querySelector('details');
          if (details && details.hasAttribute('open')) {
            closeMenu(headerMenu);
          } else {
            document.querySelectorAll('header-menu').forEach(function (other) {
              if (other !== headerMenu) closeMenu(other);
            });
            openMenu(headerMenu);
          }
        });
      }
    });

    document.addEventListener('click', function (e) {
      if (!isDesktop()) return;
      if (!e.target.closest('header-menu')) {
        document.querySelectorAll('header-menu').forEach(closeMenu);
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        document.querySelectorAll('header-menu').forEach(closeMenu);
      }
    });

    window.addEventListener('resize', repositionOpenCompactDropdowns);
    window.addEventListener('scroll', repositionOpenCompactDropdowns, { passive: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initHoverMenus);
  } else {
    initHoverMenus();
  }

  document.addEventListener('shopify:section:load', initHoverMenus);
})();
